// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3ia9C","fileDisabled":"File_fileDisabled__2TZim"};